import type { ValidationIssue } from '../../api/types';

export function IssueList({ issues }: { issues: ValidationIssue[] }) {
  const errors = issues.filter((i) => i.severity === 'error');
  const warnings = issues.filter((i) => i.severity === 'warning');

  if (errors.length === 0 && warnings.length === 0) {
    return null;
  }

  return (
    <div className="issues">
      {errors.length > 0 && (
        <div className="issues__block issues__block--error">
          <h3 className="issues__title">
            {errors.length === 1 ? '1 thing to fix' : `${errors.length} things to fix`}
          </h3>
          <ul>
            {errors.map((issue, index) => (
              <li key={`${issue.fieldKey}-${index}`}>{issue.message}</li>
            ))}
          </ul>
        </div>
      )}

      {warnings.length > 0 && (
        <div className="issues__block issues__block--warning">
          <h3 className="issues__title">
            {warnings.length === 1 ? '1 thing to check' : `${warnings.length} things to check`}
          </h3>
          <ul>
            {warnings.map((issue, index) => (
              <li key={`warning-${index}`}>{issue.message}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
